/**
 * Development-only logger utility
 * Logs are only shown in development mode, keeping production console clean
 */
export class DevLogger {
  /**
   * Log message (dev-only)
   */
  static log(...args: any[]): void {
    if (import.meta.env.DEV) {
      console.log(...args);
    }
  }

  /**
   * Info message (dev-only)
   */
  static info(...args: any[]): void {
    if (import.meta.env.DEV) {
      console.info(...args);
    }
  }

  /**
   * Warning message (dev-only)
   */
  static warn(...args: any[]): void {
    if (import.meta.env.DEV) {
      console.warn(...args);
    }
  }

  /**
   * Error message (always visible in production and dev)
   */
  static error(...args: any[]): void {
    console.error(...args);
  }
}

export const devLogger = DevLogger;